module.exports = __webpack_public_path__ + "static/april-3-070947a2d83e3c747e605cafe8858aab.png";